import React, {  useContext, useState } from 'react';
import { DataPartnerContext, ShowPartnersContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import InputsPartner from './forms/InputsPartner';
import { useDispatch } from 'react-redux';
import { AddPartnerApi } from '../../redux/partners/partnerApiCalls';
import { Timeout } from '../../functions/functions';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface AddPartnerInterface {
  modal: boolean,
  toggle: () => void,
}

const AddPartner:React.FC<AddPartnerInterface> = ({ modal, toggle }) => {
  const [name, setName] = useState("")
  const [role, setRole] = useState("")
  const [image, setImage] = useState<File | any>(null)

  const [errors, setErrors] = useState<string[]>([])

  const [loading, setLoading] = useState(false)

  const { setShowSuccessMsg } = useContext(ShowPartnersContext)
  const dispatch:any = useDispatch()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("name", name)
      formData.append("role", role)
      formData.append("image", image)
      const response: any = await dispatch(AddPartnerApi(formData))
        if(response === true) {
          setName("")
          setRole("")
          setImage(null)
          setShowSuccessMsg(true)
          setErrors([])
          toggle()
          setTimeout(() => setShowSuccessMsg(false), Timeout)
        } else {
          setErrors(response)
        }
    } finally {
      setLoading(false)
    }
  }

  return (
    <DataPartnerContext.Provider 
      value={{
        name, setName,
        role, setRole,
        image, setImage
      }}
    >      
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType='multipart/form-data'
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsPartner />
                    <ButtonsForm loading={loading} toggle={toggle} typeBtn='Ajouter' />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DataPartnerContext.Provider>
  );
}

export default AddPartner
